import { LOGIN_PAGE_PATH } from 'utils/consts/path'

export const handleAuthError = () => {
  // if (process.env.NODE_ENV !== 'production') return

  if (location.pathname !== LOGIN_PAGE_PATH) {
    location.href = `${LOGIN_PAGE_PATH}?from=${encodeURIComponent(
      location.pathname
    )}`
  }
}
